import { useState, useEffect } from 'react'
import { collectionsApi } from '../services/collectionsApi'
import type { CollectionItem } from '../types/collections'

export const useCollectionItems = (collectionId: number) => {
  const [data, setData] = useState<CollectionItem[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchItems = async () => {
      try {
        setIsLoading(true)
        const items = await collectionsApi.items.list(collectionId)
        setData(items)
        setError(null)
      } catch (err) {
        setError('Error fetching collection items')
        console.error('Error fetching collection items:', err)
      } finally {
        setIsLoading(false)
      }
    }

    if (collectionId) {
      fetchItems()
    }
  }, [collectionId])

  return { data, isLoading, error }
}